import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Notification {
  message: string
  type: NotificationType
  notifyTime: number
}

export enum NotificationType {
  Info = 'bg-blue-100 border-blue-200 text-blue-500',
  Success = 'bg-green-100 border-green-200 text-green-500',
  Warning = 'bg-yellow-100 border-yellow-200 text-yellow-500',
  Error = 'bg-red-100 border-red-200 text-red-500'
}

export const useNotifyStore = defineStore('notifyStore', () => {
  const notifications = ref<Notification[]>([])

  const notify = (messageOrError: string | Error, type: NotificationType) => {
    const message = messageOrError instanceof Error ? messageOrError.message : messageOrError
    const notification: Notification = { message, type, notifyTime: Date.now() }
    notifications.value.push(notification)
  }

  const removeNotification = (notification: Notification) => {
    notifications.value = notifications.value.filter(
      (n) => n.notifyTime !== notification.notifyTime
    )
  }

  return {
    notifications,
    notify,
    removeNotification
  }
})
